// ─────────────────────────────────────────────────────────────────────────────
// LCCA NEXUS — App Router
// ─────────────────────────────────────────────────────────────────────────────
import { Routes, Route, Navigate } from 'react-router-dom';
import { AppShell }      from '@/components/layout/AppShell';
import { Dashboard }     from '@/pages/Dashboard';
import { ProjectDetail } from '@/pages/ProjectDetail';
import { Compare }       from '@/pages/Compare';
import { Guide }         from '@/pages/Guide';

export default function App() {
  return (
    <AppShell>
      <Routes>
        <Route path="/"                 element={<Dashboard />} />
        <Route path="/projects/:id"     element={<ProjectDetail />} />
        <Route path="/compare"          element={<Compare />} />
        <Route path="/guide"            element={<Guide />} />
        <Route path="*"                 element={<Navigate to="/" replace />} />
      </Routes>
    </AppShell>
  );
}
